<template>
	<div>
		tu ide ured
	</div>
</template>

<script>

export default {
	data() {
		return {
		};
	},
	methods:{

	},

	watch: {

	},
	
	mounted(){
		//paginacija
		this.$store.state.paginacija.title = "Upravljanje uredom"
		
	}
}

</script>